import { alpha, brand, text } from '@/styles/shared';
export const noteDisplayStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    flex: 1,
    position: 'relative',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '25px',
  },
  dateContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    marginBottom: {
      xs: '10px',
      lg: '25px',
    },
  },
  calendarIcon: {
    width: '20px',
    height: '20px',
  },
  dateText: {
    ...text.body14Muted,
  },
  title: {
    ...text.title24,
  },
  noteInfo: {
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontWeight: 400,
    fontSize: '14px',
    color: '#000000',
    margin: '24px 0px 5px 0px',
  },
  copySection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '20px',
    paddingTop: '16px',
    borderTop: '1px solid rgba(0, 0, 0, 0.1)',
    gap: '16px',
    flexWrap: 'wrap',
  },
  copyInstruction: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  copyInstructionText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: '1.21em',
    color: 'rgba(0, 0, 0, 0.6)',
  },
  copyIcon: {
    width: '15.58px',
    height: '18.33px',
  },
  copyAllButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
    padding: {
      xs: '0px',
      md: '4px 8px',
    },
    borderRadius: '4px',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: alpha.purple05,
    },
    flexWrap: 'wrap',
  },
  copyAllText: (copyAnimating: boolean) => ({
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: '1.21em',
    color: copyAnimating ? '#000000' : brand.purpleAccent,
  }),
  copyAllIcon: {
    width: '16px',
    height: '19px',
  },
  contentArea: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    overflowY: 'auto',
    paddingRight: '8px',
    '&::-webkit-scrollbar': {
      width: '2px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: alpha.purple60,
      borderRadius: '1px',
    },
  },
  sectionContainer: {
    width: '100%',
    marginBottom: '24px',
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '16px',
    gap: '12px',
  },
  bulletPoint: {
    width: '6px',
    height: '6px',
    backgroundColor: '#000000',
    borderRadius: '50%',
    marginTop: '8px',
    flexShrink: 0,
  },
  sectionTitle: {
    fontFamily: 'Montserrat',
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '1.219em',
    color: '#000000',
    flex: 1,
  },
  sectionCopyIcon: {
    width: '17.29px',
    height: '17.29px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
  sectionContent: {
    fontFamily: 'Montserrat',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '1.429em',
    color: '#000000',
    whiteSpace: 'pre-line',
    marginLeft: '18px',
  },
};
